module.exports = __webpack_public_path__ + "media/images/banner/umana_mobile-01c1bf4dad6e1a987c8c5c7507d8a309.gif";